import { dew as _framebusDew } from "../framebus";
import * as _uuid2 from "@braintree/uuid";

var _uuid = "default" in _uuid2 ? _uuid2.default : _uuid2;

var exports = {},
    _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;

  var __importDefault = exports && exports.__importDefault || function (mod) {
    return mod && mod.__esModule ? mod : {
      "default": mod
    };
  };

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.subscribeReplier = void 0;

  var framebus_1 = _framebusDew();

  var uuid_1 = __importDefault(_uuid);

  function subscribeReplier(fn, origin) {
    var uuid = (0, uuid_1.default)();

    function replier(data, replyOriginHandler) {
      fn(data, replyOriginHandler);
      framebus_1.Framebus.target({
        origin: origin
      }).off(uuid, replier);
    }

    framebus_1.Framebus.target({
      origin: origin
    }).on(uuid, replier);
    return uuid;
  }

  exports.subscribeReplier = subscribeReplier;
  return exports;
}